const headers = [
  {
    text: 'refund.refund_refund-date',
    value: 'refundDate',
    width: '100px'
  },
  {
    text: 'user.user_customer-name',
    value: 'customerId',
    width: '180px'
  },
  {
    text: 'refund.refund_refund-warehousing-warehouse',
    value: 'storage.name',
    width: '100px'
  },
  {
    text: 'sale.sale_author',
    value: 'userId',
    width: '100px'
  },
  {
    text: 'common.common_status',
    value: 'status',
    width: '100px'
  },
  {
    text: 'sale.sale_price',
    value: 'refundAmount',
    width: '70px'
  }
]

const tableKey = 'refundId'

const productListHeaders = [
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '28%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '5%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'refund.refund_quantity-shelf-number',
    value: 'quantityAndStorageNo',
    sortable: false,
    width: '9%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'refund.refund_refund-purchase-unit-price',
    value: 'price',
    sortable: false,
    width: '9%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'refund.refund_refund-purchase-price',
    value: 'amount',
    sortable: false,
    width: '9%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'refund.refund_refund-unit-price',
    value: 'refundPrice',
    sortable: false,
    width: '9%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'refund.refund_refund-price',
    value: 'refundAmount',
    sortable: false,
    width: '9%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  }
]

export default { headers, tableKey, productListHeaders }
